import React, { useState } from 'react';

function ChildCareCentreSlider({ centre, isCCS, lazyFirst }) {
    const [active, setActive] = useState(1);
    const [hovering, setHovering] = useState(false);
    const [trigger, setTrigger] = useState(false);
    const [touchStart, setTouchStart] = useState(0);

    const platinum = centre.ProductSubscription === 'Ccs_Platinum';
    const wrapperClass = platinum ? 'lg:col-span-7' : '';
    const aspectClass = platinum
        ? 'aspect-w-7 aspect-h-5 lg:aspect-w-16 lg:aspect-h-14'
        : 'aspect-w-8 aspect-h-5 lg:aspect-w-11 lg:aspect-h-10 xl:aspect-w-16 xl:aspect-h-15 2xl:aspect-w-16 2xl:aspect-h-13';

    const handleTouch = (event) => {
        setTouchStart(event.changedTouches[0].pageX);
    };

    const handleSwipe = (event) => {
        const xMove = event.changedTouches[0].pageX;
        const sensitivityInPx = 10;

        if (Math.floor(touchStart - xMove) > sensitivityInPx && !trigger) {
            // Swiped Left
            setTrigger(true);
            clickRight();
            setTimeout(() => {
                setTrigger(false);
            }, 300);
        } else if (Math.floor(touchStart - xMove) < -sensitivityInPx && !trigger) {
            // Swiped Right
            setTrigger(true);
            clickLeft();
            setTimeout(() => {
                setTrigger(false);
            }, 300);
        }
    };

    const clickLeft = () => {
        document.querySelectorAll('.slider-image').forEach((x) => {
            x.setAttribute('x-transition:enter-start', 'transform -translate-x-full');
            x.setAttribute('x-transition:leave-end', 'transform translate-x-full');
        });
        setActive(active === 1 ? centre.GallaryImageIds.length : active - 1);
    };

    const clickRight = () => {
        document.querySelectorAll('.slider-image').forEach((x) => {
            x.setAttribute('x-transition:enter-start', 'transform translate-x-full');
            x.setAttribute('x-transition:leave-end', 'transform -translate-x-full');
        });
        setActive(active === centre.GallaryImageIds.length ? 1 : active + 1);
    };

    return (
        <div
            className={`relative overflow-hidden ${wrapperClass} search-result-image-slider h-full`}
            onTouchStart={handleTouch}
            onTouchMove={handleSwipe}
            onMouseOver={() => setHovering(true)}
            onMouseOut={() => setHovering(false)}
        >
            <div
                className="z-10 absolute left-0 top-0 flex h-full w-full justify-between overflow-hidden bg-transparent px-6"
                data-event-action="Gallery"
                data-id={centre.CentreUserId}
            >
                <div className="flex h-full items-center absolute left-6 top-0">
                    {!isCCS && (
                        <button
                            className={`${hovering ? 'md:inline-flex' : 'hidden'} items-center p-2 rounded-full shadow-sm text-white w-10 h-10 bg-white cursor-pointer hover:bg-gray-300 z-20`}
                            onClick={clickLeft}
                        >
                            <svg className="mx-auto w-3 h-4">
                                <use xlinkHref="/img/icons/srp-profile-core-sprite.svg#left-arrow"></use>
                            </svg>
                        </button>
                    )}
                </div>

                {/*<div className="flex flex-row h-full items-end gap-2 pb-5 slider-dots mx-auto">*/}
                {/*    {centre.GallaryImageIds.map((imageId, index) => (*/}
                {/*        <span*/}
                {/*            key={index}*/}
                {/*            className={`rounded-full w-2 h-2 lg:w-3 lg:h-3 dot-index ${active === index + 1 ? 'bg-white' : 'bg-gray-400'*/}
                {/*                }`}*/}
                {/*        ></span>*/}
                {/*    ))}*/}
                {/*</div>*/}

                <div className="flex h-full items-center absolute right-6 top-0">
                    {!isCCS && (
                        <button
                            className={`${hovering ? 'md:inline-flex' : 'hidden'} items-center p-2 rounded-full shadow-sm text-white w-10 h-10 bg-white cursor-pointer hover:bg-gray-300 z-20`}
                            onClick={clickRight}
                        >
                            <svg className="mx-auto w-3 h-4">
                                <use xlinkHref="/img/icons/srp-profile-core-sprite.svg#right-arrow"></use>
                            </svg>
                        </button>
                    )}
                </div>
            </div>

            <div className={`flex overflow-x-hidden relative h-full aspect-div ${aspectClass}`}>
                {centre.GallaryImageIds.map((imageId, index) => {
                    const addLazy = index === 0 && !lazyFirst ? '' : 'lazy';
                    const imgSrc =
                        index === 0 && !lazyFirst
                            ? `/Image/CentreThumbnail/${imageId}?w=535&h=468&q=90`
                            : '/img/lazy.gif';

                    return (
                        <div
                            key={index}
                            className="absolute slider-image overflow-hidden"
                            style={{ display: active === index + 1 ? 'block' : 'none' }}
                        >
                            <img
                                className={`object-cover h-full overflow-hidden w-full ${addLazy} slider-image-img`}
                                alt="centre image"
                                src={`/Image/CentreThumbnail/${imageId}?w=535&h=468&q=90`}
                                data-src={`/Image/CentreThumbnail/${imageId}?w=535&h=468&q=90`}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ChildCareCentreSlider;
